<template>
  <div class="tw-max-h-[90vh]">
    <PageHeader>
      <template #header-title>
        {{ $t('Job posts') }}
      </template>
      <template #header-actions>
        <WdsStack class="tw-mb-2" direction-column gap-md align-end>
          <WdsButton :href="laravelNamedRoute('frontend.flows.hiring.actions')" primary>
            <WdsStack gap-sm align-center justify-center>
              <WdsIcon :name="WdsIconNameEnum.PLUS" />

              {{ $t('New job post') }}
            </WdsStack>
          </WdsButton>

          <WdsStack direction-column align-end>
            <WdsText primary>{{ $t('Looking for a hire offer or contract?') }}</WdsText>
            <WdsStack direction-row gap-xs>
              <span class="tw-text-indigo-500">{{ $t('You can now find them in') }}</span>

              <a class="tw-underline" :href="laravelNamedRoute('frontend.profiles.index.engaged')">
                {{ $t('Hires') }}
              </a>
            </WdsStack>
          </WdsStack>
        </WdsStack>
      </template>
    </PageHeader>

    <JobsGraphqlTable />
  </div>
</template>

<script lang="ts" setup>
import {
  WdsButton,
  WdsIcon,
  WdsIconNameEnum,
  WdsStack,
  WdsText,
} from '@worksome/wds-components'
import PageHeader from '@/components/PageHeader.vue'
import { $t } from '@/composables/translation'
import JobsGraphqlTable from '@/components/Job/Table/JobsGraphqlTable.vue'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
</script>

<style lang="scss" scoped></style>
